module.exports = __webpack_public_path__ + "giving/public/shared/assets/credit_card@2x.svg?5a91cced292e94f7d01d9c9cafcaaa17";